module.exports = __webpack_public_path__ + "static/intro-79fcdc0289052dec046dd4d059ece942.png";